import { jwtDecode } from "jwt-decode";

export const url: string = "https://jmld.cz/"; // Adjust the URL as needed

interface JWTPayload {
    exp: number;
    [key: string]: any;
}

interface LoginFormData {
    user: string;
    pass: string;
}

export const getJWT = async (loginData: LoginFormData): Promise<string | null> => {
    try {
        const urlLogin = url + "api/login";
        const response = await fetch(urlLogin, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(loginData),
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return data.jwt;
        
    } catch (error) {
        console.log('Error fetching JWT:', error);
        return null;
    }
};

export const isTokenExpired = (token: string): boolean => {
    try {
        const decoded = jwtDecode<JWTPayload>(token);
        const currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp < currentTime;
    } catch (error) {
        console.log("Invalid token:", error);
        return true;
    }
};